export default {
    base_page: {
        title: '¿Quieres un módulo de reserva igual para tu alojamiento?',
        description: 'Este módulo de reserva se creó con RealtyCalendar',
        button: 'Más información',
    },
    common: {
        months: [
            'enero',
            'febrero',
            'marzo',
            'abril',
            'mayo',
            'junio',
            'julio',
            'agosto',
            'septiembre',
            'octubre',
            'noviembre',
            'diciembre',
        ],
        back: 'Atrás',
        book: 'Reservar',
        more: 'Más información',
        from: 'desde',
        find: 'Buscar',
        reset: 'Restablecer',
        apply: 'Aplicar',
        cancel: 'Cancelar',
        close: 'Cerrar',
        print: 'Imprimir',
        change: 'Cambiar',
        arrival: 'Llegada',
        by_list: 'Lista',
        by_map: 'Mapa',
        download_confirmation: 'Descargar confirmación de la reserva',
        guests: {
            adults: 'Adultos',
            child: 'Niño:',
            add_child: 'Añadir niño',
            guest: '{count} huéspedes | {count} huésped | {count} huésped | {count} huéspedes | {count} huéspedes',
            child_count: '{count} niños | {count} niño | {count} niño | {count} niños | {count} niños',
            list: 'Lista de huéspedes',
        },
        confirm_close: {
            title: '¿Seguro que quieres cerrar la ventana?',
            text: 'Al cerrar, se perderán tus datos de la reserva.',
        },
        meta: {
            title: 'Módulo de reserva',
            description: 'Tu alojamiento ideal te espera. ¡Reserva en segundos!',
        },
        select_date: 'Elegir fecha',
        departure: 'Salida',
        refresh: 'Actualizar',
        year: '{count} años | {count} año | {count} año | {count} años | {count} años',
    },
    calendar: {
        check_in: 'Entrada',
        check_out: 'Salida',
        check_in_check_out: 'Entrada–Salida',
        select_date: 'Selecciona una fecha',
        select_check_in_date: 'Selecciona la fecha de entrada',
        select_check_out_date: 'Selecciona la fecha de salida',
        departure_only_hint: 'solo salida disponible',
        check_in_date_with_time: 'Entrada {date} - Selecciona la fecha de salida',
        check_in_check_out_dates: 'Entrada {checkIn} - salida {checkOut}',
        check_in_date: 'Fecha de llegada',
        check_out_date: 'Fecha de salida',
        booking_min_days: 'Reserva mínima de {days} días',
        discount_days: 'descuento desde {days} días',
        while_staying: 'para estancias',
    },
    basket: {
        title: 'Reserva',
        arrival_time: 'Hora de entrada',
        departure_time: 'Hora de salida',
        select_time: 'Selecciona una hora',
        booking_params: 'Detalles de la reserva',
        form: {
            first_name: 'Nombre',
            last_name: 'Apellidos',
            phone: 'Teléfono',
            additional_phone: 'Teléfono adicional (opcional)',
            email: 'Email',
            email_optional: 'Email (opcional)',
            wishes: 'Tus solicitudes (opcional)',
            enter_name: 'Introduce tu nombre',
            enter_last_name: 'Introduce tus apellidos',
            enter_phone: 'Introduce tu número',
            enter_email: 'Introduce tu email',
            placeholder_wishes: 'Deja una nota para el propietario',
        },
        price: {
            cost: 'Precio',
            select_tariff: 'Elija una tarifa',
            stay_amount: 'Importe {period}',
            total: 'Total',
            long_stay_discount: 'Descuento por estancia larga',
            rate_discount: 'Descuento por tarifa',
            promo_code_discount: 'Descuento por código promocional',
            processing_fee: 'Procesamiento del pago',
            payment_system_fee: 'Comisión del sistema de pago',
            service_fee: 'Tarifa de servicio',
            service_fee_tooltip: 'Los fondos se abonan primero en la cuenta del proveedor de pago y luego se transfieren al propietario después de tu salida. La tarifa de servicio garantiza una transacción segura y protege tus intereses como huésped.',
            pay_now: 'Importe a pagar ahora',
            pay_later: 'Pagar al hacer el check-in',
            pay_later_tooltip: 'El propietario se pondrá en contacto contigo con antelación para explicarte cómo realizar el pago. Algunos propietarios también pueden solicitar un depósito de seguridad.',
            select_dates_and_guests: 'Selecciona las fechas de entrada y salida y el número de huéspedes',
            payment_method: {
                title: 'Método de pago',
                sbp: 'SBP',
                card: 'Tarjeta bancaria',
            },
        },
        agreement: {
            text: `Doy mi {consentLink}consentimiento para el tratamiento de datos personales{/consentLink},
        y confirmo que he leído las {bookingRulesLink}Normas de reserva{/bookingRulesLink},
        las condiciones de la oferta {safeTransactionsLink}Transferencia sin riesgo{/safeTransactionsLink}
        y la {privacyLink}Política de tratamiento de datos personales{/privacyLink}.`,
            consent_text: `Doy mi {consentLink}consentimiento para el tratamiento de datos personales{/consentLink}.`,
            rules_text: `Confirmo que he leído las {bookingRulesLink}Normas de reserva{/bookingRulesLink}, las condiciones de la oferta {safeTransactionsLink}Transferencia sin riesgo{/safeTransactionsLink} y la {privacyLink}Política de tratamiento de datos personales{/privacyLink}.`,
            safe_transactions: 'Transferencia sin riesgos',
            privacy_policy: 'Política de tratamiento de datos personales',
            accommodation_rules: 'Normas del alojamiento',
            booking_rules: 'Normas de reserva',
            foreign: {
                text: `Acepto {agreementLink}los términos de reserva, las normas de alojamiento y la política de privacidad{/agreementLink}.`,
            },
        },
        validation: {
            enter_check_in_date: 'Selecciona la fecha de entrada',
            enter_check_out_date: 'Selecciona la fecha de salida',
            enter_name_required: 'Introduce tu nombre',
            name_min_length: 'El nombre debe tener al menos 2 caracteres',
            name_letters_only: 'El nombre solo puede contener letras',
            enter_last_name_required: 'Introduce tus apellidos',
            last_name_min_length: 'Los apellidos deben tener al menos 2 caracteres',
            last_name_letters_only: 'Los apellidos solo pueden contener letras',
            enter_phone_required: 'Introduce tu número de teléfono',
            phone_invalid: 'Introduce un número de teléfono válido',
            enter_email_required: 'Introduce tu email',
            email_invalid: 'Introduce un email válido',
        },
        payment: {
            timer_text: 'Realiza el pago por adelantado lo antes posible mientras el alojamiento siga disponible. Se te redirigirá al servicio de pago. Tras el pago, el alojamiento quedará reservado para ti.',
        },
        promocode: {
            enter_promocode: 'Introducir código promocional',
            promocode: 'Código promocional',
            enter_code: 'Introduce el código promocional',
            discount: 'Descuento por código promocional',
        },
    },
    hotel: {
        details: {
            description: 'Descripción',
            amenities: 'Servicios y comodidades',
            show_all_amenities: 'Ver todas las comodidades: {count}',
            address: 'Dirección',
            classification_certificate: 'Certificado de clasificación n.º {number}',
        },
        apartment: {
            room: '{count} habitaciones | {count} habitación | {count} habitación | {count} habitaciones | {count} habitaciones',
            bed: '{count} plazas para dormir | {count} plaza para dormir | {count} plaza para dormir | {count} plazas para dormir | {count} plazas para dormir',
            available_dates: 'Fechas disponibles',
            date_range_sold_out: 'No hay disponibilidad para {range}.',
            select_free_dates: 'Selecciona fechas disponibles en el calendario.',
            booking_available_from: 'reserva disponible a partir de {minStay} noches.',
            date_range_on: 'Para {range}',
            rooms: 'Habitaciones',
            area: 'Superficie',
            floor: 'Planta',
            beds: 'Plazas para dormir',
            day_off: 'en {count} días | en {count} día | en {count} día | en {count} días | en {count} días',
            night_off: 'en {count} noches | en {count} noche | en {count} noche | en {count} noches | en {count} noches',
        },
        map: {
            found: 'Encontrados',
            scroll: 'Desplázate para ver todos',
            variant: '{count} opciones | {count} opción | {count} opción | {count} opciones | {count} opciones',
            metro: 'Metro',
        },
    },
    room_attributes: {
        washing_machine: 'Lavadora',
        wi_fi: 'Internet Wi-Fi',
        tv: 'Televisión',
        air_conditioning: 'Aire acondicionado',
        refrigerator: 'Nevera',
        dishwasher: 'Lavavajillas',
        music_center: 'Equipo de música',
        microwave: 'Microondas',
        iron: 'Plancha y tabla de planchar',
        concierge: 'Conserje',
        parking: 'Aparcamiento',
        safe: 'Caja fuerte',
        waterheater: 'Calentador de agua',
        bathroom: 'Artículos de baño',
        animals: 'Se admiten mascotas',
        smoke: 'Se permite fumar',
        balcony: 'Balcón',
        elevator: 'Ascensor',
        romantic: 'Ideal para escapadas románticas',
        jacuzzi: 'Con jacuzzi',
        kids: 'Se admiten niños',
        party: 'Apto para eventos',
        telephone: 'Teléfono',
        stove: 'Cocina',
        cabletv: 'Televisión por cable',
        pool: 'Piscina',
        seafront: 'Primera línea de playa',
        playground: 'Zona infantil',
        sauna: 'Sauna',
        transfer: 'Traslado',
        seaview: 'Vistas al mar',
        mountainview: 'Vistas a la montaña',
        crib: 'Cuna',
    },
    error: {
        map_loading_failed: 'No se pudieron cargar todos los alojamientos disponibles.',
        no_rooms: 'No hay disponibilidad',
        no_rooms_text: 'No se han encontrado opciones disponibles para las fechas seleccionadas. Ponte en contacto con nosotros: ¡siempre tenemos algo que ofrecer!',
        occurred: 'Se produjo un error',
        booking_error_text: 'Algo ha salido mal. Ponte en contacto con nosotros:',
        connect_error_text: 'Se perdió la conexión con el servidor durante la búsqueda. Vuelve a intentarlo.',
        return_to_apartments: 'Volver a los alojamientos',
        validation: 'Error de validación',
        not_found: 'Algo salió mal. Esta página no existe',
    },
    success: {
        booked: 'Reservado',
        thanks: '¡Gracias! Has reservado correctamente {address}',
        booking_info: 'Detalles de la reserva',
        check_in: 'Entrada',
        check_out: 'Salida',
        amount: 'Importe',
        prepaid: 'Pago por adelantado realizado',
        pay_on_arrival: 'Pagar a la llegada',
        message_for_you: 'Mensaje para ti',
        check_in_date_time: '{date}, de {timeStart} a {timeEnd}',
        check_out_date_time: '{date}, de {timeStart} a {timeEnd}',
        notifications: {
            title: 'Notificaciones gratuitas',
            description: 'Te avisaremos de lo importante sobre tu reserva',
            connect_button: 'Conectar en Telegram',
        },
    },
    days: {
        day: '{count} días | {count} día | {count} día | {count} días | {count} días',
    },
    loader: {
        loading: 'Cargando...',
        searching: 'Buscando opciones disponibles...',
        checking: 'Comprobando precios...',
    },
    rules: {
        privacy_policy: 'Política de tratamiento de datos personales',
        accommodation_rules: 'Normas del alojamiento',
        booking_rules: 'Normas de reserva',
        consent: {
            title: 'Consentimiento para el tratamiento de datos personales',
            title2: 'Política de tratamiento de datos personales',
            text: `Настоящим, я, действуя свободно, своей волей и в своем интересе, а также подтверждая свою дееспособность, предоставляя данные о себе, даю согласие {legalName}, ИНН {inn}, (далее – Оператор) на обработку следующих моих персональных данных, указанных мною при бронировании Проживания на сайте https://homereserve.ru или иным способом, с целью оформления и исполнения бронирования Проживания, в том числе оказания дополнительных услуг в Средстве/Объекте размещения Оператора: {<br>}

                    - фамилия, имя, отчество (при наличии); {<br>}
                    - контактная информация (номер телефона, адрес электронной почты); {<br>}
                    - гражданство; {<br>}
                    - дата рождения (число/месяц/год); {<br>}
                    - данные документа, удостоверяющего личность (серия, номер, дата выдачи, код подразделения, орган, выдавший документ, 
                    страна рождения, регион рождения, район, город, населенный пункт); {<br>}
                    - пол;  {<br>}
                    - адрес регистрации; {<br>}
                    - информация о гостях и их персональные данные. {<br>}

                    Для достижения указанной цели Оператор может осуществлять любые действия (операции) или совокупности действий (операций), 
                    совершаемых с использованием средств автоматизации или без использования таких средств с персональными данными, указанными выше,
                    включая сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, 
                    передачу (предоставление, доступ), обезличивание, блокирование, удаление, уничтожение персональных данных. {<br>}

                    Я даю согласие Оператору на передачу (предоставление, доступ) персональных данных, указанных выше, в адрес следующего юридического лица, действующего по поручению Оператора: ООО «Апартмент системс», ИНН 7729748911 ОГРН 1137746760381, юридический адрес: 119607, г. Москва, ул. Раменки, д. 25 к. 3, кв. 668, а также иным третьим лицам через ООО «Апартмент системс» (для целей интеграции с системами бронирования, CRM-системами) в целях автоматизации бизнес-процессов, централизованного хранения и управления данными, а также осуществление с ними следующих действий (операций): сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передачу (предоставление, доступ), обезличивание, блокирование, удаление, уничтожение. {<br>}
                    
                    Я подтверждаю, что предоставленные мной персональные данные являются точными, актуальными и достоверными, 
                    также обязуюсь своевременно информировать Оператора об изменениях в моих персональных данных по адресу электронной почты: 
                    {legalEmail}, либо в письменной форме на адрес: {legalAddress}. {<br>}

                    Настоящим подтверждаю, что в случае оформления мною заказа для третьих лиц, предоставляю персональные данные с их согласия. {<br>}
                    Настоящее согласие вступает в силу с момента его предоставления, путем проставления галочки на сайте https://homereserve.ru. {<br>}
                    Согласие действует до факта достижения цели обработки или до отзыва согласия. {<br>}

                    В соответствии с положениями ч. 2 ст. 9 Федерального закона от 27 июля 2006 г. № 152-ФЗ «О персональных данных», 
                    оставляю за собой право отозвать данное согласие посредством направления такого отзыва по адресу электронной почты: 
                    {legalEmail}, либо в письменной форме на адрес: {legalAddress}. {<br>}

                    Я предупрежден(а), что в случае отзыва согласия на обработку персональных данных Оператор вправе продолжить обработку 
                    персональных данных без согласия при наличии оснований, указанных в пп. 2-11 ч. 1 ст. 6, ч. 2 ст. 10 
                    Федерального закона от 27 июля 2006 г. № 152-ФЗ «О персональных данных»`,
        },
        privacy: {
            title: 'Política de tratamiento de datos personales',
            text: `1.ОБЩИЕ ПОЛОЖЕНИЯ {<br>}

                    1.1.Настоящая Политика в отношении обработки персональных данных (далее – Политика) разработана во исполнение требований п. 2 ч. 1 ст. 18.1 Федерального закона от 27.07.2006 г. № 152-ФЗ «О персональных данных» в целях обеспечения защиты прав и свобод человека и гражданина при обработке его персональных данных, в том числе, защиты прав на неприкосновенность частной жизни, личную и семейную тайну. {<br>}
                    1.2.Политика действует в отношении всех персональных данных, которые обрабатывает {legalName}, ИНН {inn} (далее – Оператор). {<br>}
                    1.3.Политика распространяется на отношения в области обработки персональных данных, возникшие у Оператора как до, так и после утверждения Политики. {<br>}
                    1.4.Во исполнение требований ч. 2 ст. 18.1 Федерального закона от 27.07.2006 г. № 152-ФЗ «О персональных данных», Политика публикуется в личном кабинете Оператора в RealtyCalendar. {<br>}

                    2.ОСНОВНЫЕ ПОНЯТИЯ, ИСПОЛЬЗУЕМЫЕ В ПОЛИТИКЕ {<br>}

                    2.1.Персональные данные – любая информация, относящаяся к прямо или косвенно определенному или определяемому физическому лицу (субъекту персональных данных); {<br>}
                    2.2.Оператор персональных данных (оператор) – государственный орган, муниципальный орган, юридическое или физическое лицо, самостоятельно или совместно с другими лицами организующие и (или) осуществляющие обработку персональных данных, а также определяющие цели обработки персональных данных, состав персональных данных, подлежащих обработке, действия (операции), совершаемые с персональными данными; {<br>}
                    2.3.Обработка персональных данных – любое действие (операция) или совокупность действий (операций) с персональными данными, совершаемых с использованием средств автоматизации или без их использования. Обработка персональных данных включает в себя в том числе: {<br>}
                    2.3.1.сбор; {<br>}
                    2.3.2.запись; {<br>}
                    2.3.3.систематизацию; {<br>}
                    2.3.4.накопление; {<br>}
                    2.3.5.хранение; {<br>}
                    2.3.6.уточнение (обновление, изменение); {<br>}
                    2.3.7.извлечение; {<br>}
                    2.3.8.использование; {<br>}
                    2.3.9.передачу (распространение, предоставление, доступ); {<br>}
                    2.3.10.обезличивание; {<br>}
                    2.3.11.блокирование; {<br>}
                    2.3.12.удаление; {<br>}
                    2.3.13.уничтожение. {<br>}
                    2.4.Автоматизированная обработка персональных данных – обработка персональных данных с помощью средств вычислительной техники; {<br>}
                    2.5.Распространение персональных данных – действия, направленные на раскрытие персональных данных неопределенному кругу лиц; {<br>}
                    2.6.Предоставление персональных данных – действия, направленные на раскрытие персональных данных определенному лицу или определенному кругу лиц; {<br>}
                    2.7.Блокирование персональных данных – временное прекращение обработки персональных данных (за исключением случаев, если обработка необходима для уточнения персональных данных); {<br>}
                    2.8.Уничтожение персональных данных – действия, в результате которых становится невозможным восстановить содержание персональных данных в информационной системе персональных данных и (или) в результате которых уничтожаются материальные носители персональных данных; {<br>}
                    2.9.Обезличивание персональных данных – действия, в результате которых становится невозможным без использования дополнительной информации определить принадлежность персональных данных конкретному субъекту персональных данных; {<br>}
                    2.10.Информационная система персональных данных – совокупность содержащихся в базах данных персональных данных и обеспечивающих их обработку информационных технологий и технических средств; {<br>}
                    2.11.Трансграничная передача персональных данных – передача персональных данных на территорию иностранного государства органу власти иностранного государства, иностранному физическому лицу или иностранному юридическому лицу. {<br>}

                    3.ОСНОВНЫЕ ПРАВА И ОБЯЗАННОСТИ ОПЕРАТОРА {<br>}

                    3.1.Оператор имеет право: {<br>}
                    3.1.1.самостоятельно определять состав и перечень мер, необходимых и достаточных для обеспечения выполнения обязанностей, предусмотренных Федеральным законом от 27.07.2006 г. № 152-ФЗ «О персональных данных» и принятыми в соответствии с ним нормативными правовыми актами, если иное не предусмотрено Федеральным законом от 27.07.2006 г. № 152-ФЗ «О персональных данных» или другими федеральными законами; {<br>}
                    3.1.2.поручить обработку персональных данных другому лицу с согласия субъекта персональных данных, если иное не предусмотрено федеральным законом, на основании заключаемого с этим лицом договора. Лицо, осуществляющее обработку персональных данных по поручению Оператора, обязано соблюдать принципы и правила обработки персональных данных, предусмотренные Федеральным законом от 27.07.2006 г. № 152-ФЗ «О персональных данных»; {<br>}
                    3.1.3.в случае отзыва субъектом персональных данных согласия на обработку персональных данных Оператор вправе продолжить обработку персональных данных без согласия субъекта персональных данных при наличии оснований, указанных в Федеральном законе от 27.07.2006 г. № 152-ФЗ «О персональных данных». {<br>}
                    3.2. Оператор обязан: {<br>}
                    3.2.1.организовывать обработку персональных данных в соответствии с требованиями Федерального закона от 27.07.2006 г. № 152-ФЗ «О персональных данных»; {<br>}
                    3.2.2.отвечать на обращения и запросы субъектов персональных данных и их законных представителей в соответствии с требованиями Федерального закона от 27.07.2006 г. № 152-ФЗ «О персональных данных»; {<br>}
                    3.2.3.сообщать в уполномоченный орган по защите прав субъектов персональных данных (Федеральную службу по надзору в сфере связи, информационных технологий и массовых коммуникаций (Роскомнадзор)) по запросу этого органа необходимую информацию в течение 10 (десяти) рабочих дней с даты получения такого запроса. {<br>}

                    4.ОСНОВНЫЕ ПРАВА СУБЪЕКТА ПЕРСОНАЛЬНЫХ ДАННЫХ {<br>}

                    4.1.Субъект персональных данных имеет право: {<br>}
                    4.1.1.получать информацию, касающуюся обработки его персональных данных, за исключением случаев, предусмотренных федеральными законами. Сведения предоставляются субъекту персональных данных Оператором в доступной форме, и в них не должны содержаться персональные данные, относящиеся к другим субъектам персональных данных, за исключением случаев, когда имеются законные основания для раскрытия таких персональных данных. Перечень информации и порядок ее получения установлен Федеральным законом от 27.07.2006 г. № 152-ФЗ «О персональных данных»; {<br>}
                    4.1.2.требовать от оператора уточнения его персональных данных, их блокирования или уничтожения в случае, если персональные данные являются неполными, устаревшими, неточными, незаконно полученными или не являются необходимыми для заявленной цели обработки, а также принимать предусмотренные законом меры по защите своих прав; {<br>}
                    4.1.3.выдвигать условие предварительного согласия при обработке персональных данных в целях продвижения на рынке товаров, работ и услуг; {<br>}
                    4.1.4.обжаловать в административном или судебном порядке неправомерные действия или бездействие Оператора при обработке его персональных данных. {<br>}
                    4.2. Контроль за исполнением требований настоящей Политики осуществляется Оператором или уполномоченным лицом, ответственным за организацию обработки персональных данных у Оператора. {<br>}
                    4.3. Ответственность за нарушение требований законодательства Российской Федерации и локальных нормативных актов Оператора в сфере обработки и защиты персональных данных определяется в соответствии с законодательством Российской Федерации. {<br>}

                    5.ЦЕЛИ СБОРА ПЕРСОНАЛЬНЫХ ДАННЫХ {<br>}

                    5.1.Обработка персональных данных ограничивается достижением конкретных, заранее определенных и законных целей. Не допускается обработка персональных данных, несовместимая с целями сбора персональных данных. {<br>}
                    5.2.Обработке подлежат только персональные данные, которые отвечают целям их обработки. {<br>}
                    5.3.Обработка Оператором персональных данных осуществляется в следующих целях: {<br>}
                    5.3.1.обеспечение соблюдения Конституции Российской Федерации, федеральных законов и иных нормативных правовых актов Российской Федерации; {<br>}
                    5.3.2.осуществление деятельности Оператора; {<br>}
                    5.3.3.ведение делопроизводства; {<br>}
                    5.3.4.заполнение и передача в органы исполнительной власти и иные уполномоченные организации требуемых форм отчетности; {<br>}
                    5.3.5.осуществление гражданско-правовых отношений; {<br>}
                    5.3.6.ведение бухгалтерского учета. {<br>}

                    6.ОБЪЕМ И КАТЕГОРИИ ОБРАБАТЫВАЕМЫХ ПЕРСОНАЛЬНЫХ ДАННЫХ, КАТЕГОРИИ СУБЪЕКТОВ ПЕРСОНАЛЬНЫХ ДАННЫХ {<br>}

                    6.1.Оператор может обрабатывать персональные данные следующих категорий субъектов персональных данных. {<br>}
                    6.1.1.Клиенты и контрагенты Оператора (физические лица): {<br>}
                    - фамилия, имя, отчество (при наличии); {<br>}
                    - контактная информация (номер телефона, адрес электронной почты); {<br>}
                    - гражданство; {<br>}
                    - дата рождения (число/месяц/год); {<br>}
                    - данные документа, удостоверяющего личность (серия, номер, дата выдачи, код подразделения, орган, выдавший документ, страна рождения, регион рождения, район, город, населенный пункт); {<br>}
                    - пол; {<br>}
                    - адрес регистрации; {<br>}
                    - информация о гостях и их персональные данные. {<br>}
                    6.2.Обработка Оператором биометрических персональных данных (сведений, которые характеризуют физиологические и биологические особенности человека, на основании которых можно установить его личность) не осуществляется. {<br>}
                    6.3.Оператором не осуществляется обработка специальных категорий персональных данных, касающихся расовой, национальной принадлежности, политических взглядов, религиозных или философских убеждений, состояния здоровья, интимной жизни, за исключением случаев, предусмотренных законодательством РФ. {<br>}

                    7.ПОРЯДОК И УСЛОВИЯ ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ {<br>}

                    7.1.Обработка персональных данных осуществляется Оператором в соответствии с требованиями законодательства Российской Федерации. {<br>}
                    7.2.Обработка персональных данных осуществляется с согласия субъектов персональных данных на обработку их персональных данных, а также без такового в случаях, предусмотренных законодательством Российской Федерации. {<br>}
                    7.3.Оператор осуществляет как автоматизированную, так и неавтоматизированную обработку персональных данных. {<br>}
                    7.4.К обработке персональных данных допускаются работники Оператора, в должностные обязанности которых входит обработка персональных данных. {<br>}
                    7.5.Обработка персональных данных осуществляется путем: {<br>}
                    7.5.1.получения персональных данных в устной и письменной форме непосредственно от субъектов персональных данных; {<br>}
                    7.5.2.получения персональных данных из общедоступных источников; {<br>}
                    7.5.3.внесения персональных данных в журналы, реестры и информационные системы Оператора; {<br>}
                    7.5.4.использования иных способов обработки персональных данных. {<br>}
                    7.6.Не допускается раскрытие третьим лицам и распространение персональных данных без согласия субъекта персональных данных, если иное не предусмотрено федеральным законом. Согласие на обработку персональных данных, разрешенных субъектом персональных данных для распространения, оформляется отдельно от иных согласий субъекта персональных данных на обработку его персональных данных. {<br>}
                    Требования к содержанию согласия на обработку персональных данных, разрешенных субъектом персональных данных для распространения, утверждены Приказом Роскомнадзора от 24.02.2021 г. № 18 (а в случае его отмены в последующем – в заменяющем его нормативно-правовом акте). {<br>}
                    7.7.Передача персональных данных органам дознания и следствия, в Федеральную налоговую службу, Социальный фонд Российской Федерации и другие уполномоченные органы исполнительной власти и организации осуществляется в соответствии с требованиями законодательства Российской Федерации. {<br>}
                    7.8.Оператор принимает необходимые правовые, организационные и технические меры для защиты персональных данных от неправомерного или случайного доступа к ним, уничтожения, изменения, блокирования, распространения и других несанкционированных действий, в том числе: {<br>}
                    - определяет угрозы безопасности персональных данных при их обработке; {<br>}
                    - принимает локальные нормативные акты и иные документы, регулирующие отношения в сфере обработки и защиты персональных данных; {<br>}
                    - назначает лиц, ответственных за обеспечение безопасности персональных данных в структурных подразделениях и информационных системах Оператора; {<br>}
                    - создает необходимые условия для работы с персональными данными; {<br>}
                    - организует учет документов, содержащих персональные данные; {<br>}
                    - организует работу с информационными системами, в которых обрабатываются персональные данные; {<br>}
                    - хранит персональные данные в условиях, при которых обеспечивается их сохранность и исключается неправомерный доступ к ним; {<br>}
                    - организует обучение работников Оператора, осуществляющих обработку персональных данных. {<br>}
                    7.9.Оператор осуществляет хранение персональных данных в форме, позволяющей определить субъекта персональных данных, не дольше, чем этого требуют цели обработки персональных данных, если срок хранения персональных данных не установлен федеральным законом, договором. {<br>}
                    7.10.При сборе персональных данных, в том числе посредством информационно-телекоммуникационной сети «Интернет», запись, систематизация, накопление, хранение, уточнение (обновление, изменение), извлечение персональных данных граждан Российской Федерации с использованием баз данных, находящихся за пределами территории Российской Федерации, не допускаются, за исключением случаев, указанных в пунктах 2, 3, 4, 8 части 1 статьи 6 Федерального закона от 27.07.2006 г. № 152-ФЗ «О персональных данных». {<br>}

                    8.АКТУАЛИЗАЦИЯ, ИСПРАВЛЕНИЕ, УДАЛЕНИЕ И УНИЧТОЖЕНИЕ ПЕРСОНАЛЬНЫХ ДАННЫХ, ОТВЕТЫ НА ЗАПРОСЫ СУБЪЕКТОВ НА ДОСТУП К ПЕРСОНАЛЬНЫМ ДАННЫМ {<br>}

                    8.1.Подтверждение факта обработки персональных данных Оператором, правовые основания и цели обработки персональных данных, а также иные сведения, указанные в ч. 7 ст. 14 Федерального закона от 27.07.2006 г. № 152-ФЗ «О персональных данных», предоставляются Оператором субъекту персональных данных или его представителю при обращении либо при получении запроса субъекта персональных данных или его представителя по адресу электронной почты: {legalEmail}, либо в письменной форме на адрес: {legalAddress}. {<br>}
                    В предоставляемые сведения не включаются персональные данные, относящиеся к другим субъектам персональных данных, за исключением случаев, когда имеются законные основания для раскрытия таких персональных данных. {<br>}
                    Запрос должен содержать: {<br>}
                    - номер основного документа, удостоверяющего личность субъекта персональных данных или его представителя, сведения о дате выдачи указанного документа и выдавшем его органе; {<br>}
                    - сведения, подтверждающие участие субъекта персональных данных в отношениях с Оператором (номер договора, дата заключения договора, условное словесное обозначение и (или) иные сведения), либо сведения, иным образом подтверждающие факт обработки персональных данных Оператором; {<br>}
                    - подпись субъекта персональных данных или его представителя. {<br>}
                    Запрос может быть направлен в форме электронного документа и подписан электронной подписью в соответствии с законодательством Российской Федерации. {<br>}
                    Если в обращении (запросе) субъекта персональных данных не отражены в соответствии с требованиями Федерального закона от 27.07.2006 г. № 152-ФЗ «О персональных данных» все необходимые сведения или субъект не обладает правами доступа к запрашиваемой информации, то ему направляется мотивированный отказ. {<br>}
                    Право субъекта персональных данных на доступ к его персональным данным может быть ограничено в соответствии с ч. 8 ст. 14 Федерального закона от 27.07.2006 г. № 152-ФЗ «О персональных данных», в том числе, если доступ субъекта персональных данных к его персональным данным нарушает права и законные интересы третьих лиц. {<br>}
                    8.2.В случае выявления неточных персональных данных при обращении субъекта персональных данных или его представителя либо по их запросу или по запросу Роскомнадзора Оператор осуществляет блокирование персональных данных, относящихся к этому субъекту персональных данных, с момента такого обращения или получения указанного запроса на период проверки, если блокирование персональных данных не нарушает права и законные интересы субъекта персональных данных или третьих лиц. {<br>}
                    В случае подтверждения факта неточности персональных данных Оператор на основании сведений, представленных субъектом персональных данных или его представителем либо Роскомнадзором, или иных необходимых документов уточняет персональные данные в течение семи рабочих дней со дня представления таких сведений и снимает блокирование персональных данных. {<br>}
                    8.3.При достижении целей обработки персональных данных, а также в случае отзыва субъектом персональных данных согласия на их обработку персональные данные подлежат уничтожению, если: {<br>}
                    - иное не предусмотрено договором, стороной которого, выгодоприобретателем или поручителем, по которому является субъект персональных данных; {<br>}
                    - Оператор не вправе осуществлять обработку без согласия субъекта персональных данных на основаниях, предусмотренных Федеральным законом от 27.07.2006 г. № 152-ФЗ «О персональных данных» или иными федеральными законами; {<br>}
                    - иное не предусмотрено другим соглашением между Оператором и субъектом персональных данных. {<br>}

                    9.ЗАКЛЮЧИТЕЛЬНЫЕ ПОЛОЖЕНИЯ {<br>}

                    9.1.Политика вступает в силу с момента утверждения Оператором и действует бессрочно. {<br>}
                    9.2.Внесение изменений, дополнение или отмена Политики производится на основании принятия Оператором соответствующего решения. {<br>}`,
        },
        booking: {
            main: {
                title: 'Normas de reserva',
            },
            another: {
                title: 'Otras normas de reserva',
            },
            refund: {
                title: 'Normas de devolución del prepago',
            },
        },
        residence: {
            title: 'Normas de estancia',
        },
        foreign_agreement: {
            title: 'Términos de reserva, normas de alojamiento y política de privacidad',
        },
    },
    hotels: {
        map: {
            close_list: 'Cerrar lista',
        },
    },
    apartment: {
        arrival_departure_text: 'Llegada de {in_start} a {in_end}, salida de {out_start} a {out_end}',
    },
    payment: {
        info: {
            error: {
                title: 'El enlace ha caducado',
                description: 'Contacta con tu gestor:',
                agreement_required: 'Debes aceptar las condiciones de la oferta',
            },
            check_in: 'Llegada',
            check_out: 'Salida',
            amount: 'Precio total',
            paid_amount: 'Pagado',
            amount_left: 'Importe a pagar',
            time_from: 'desde {from}',
            time_to: 'hasta {to}',
        },
        status: {
            success: 'Pagado',
            not_paid: 'Alojamiento no pagado',
        },
    },
    gallery: {
        large_photo: 'Foto grande',
        small_photo: 'Foto pequeña',
        more_photos: '+{count} fotos',
    },
};
